export default {
    intro: 'Dùng gợi ý phụ âm đầu và nghĩa để suy luận từ vựng!',
    meaning: 'Nghĩa',
    example: 'Ví dụ',
    table: {
        question: 'Từ vựng',
        emptyMessage: 'Không có nội dung.',
        answerRate: 'Tỷ lệ đúng',
    },
    student: {
        selectionGuide: 'Bạn có thể đoán được từ vựng từ những gợi ý này không?',
        know: 'Tôi biết!',
        dontKnow: 'Tôi không biết',
        submit: 'Gửi',
        next: 'Tiếp theo',
        inputGuide: 'Hãy nhập từ vựng bạn nghĩ đến!',
        inputPlaceholder: 'Nhập câu trả lời',
        meaningN: 'Nghĩa {n}',
        imageN: 'Hình {n}',
        videoN: 'Video {n}',
        additionalMaterials: 'Tài liệu bổ sung',
    },
    result: {
        myAnswer: 'Câu trả lời của tôi:',
        know: 'Biết',
        dontKnow: 'Không biết',
        dontKnowBracket: '(Không biết)',
    },
    stats: {
        mostIncorrect: 'Từ sai nhiều nhất',
        vocabulary: 'Từ vựng',
        meaning: 'Nghĩa',
        accuracy: 'Độ chính xác',
        moreN: 'và {n} từ khác',
    },
    reactions: {
        knowSelect: [
            'Ồ! Bạn tự tin quá!',
            'Tuyệt! Cùng kiểm tra nhé!',
            'Hay lắm! Xem bạn đúng không nhé!',
            'Giỏi quá! Đó là từ gì nhỉ?',
            'Tuyệt vời! Cùng xem đáp án nào!',
        ],
        correct: [
            'Đúng rồi! Bạn giỏi lắm!',
            'Wow! Bạn biết chính xác luôn!',
            'Chính xác! Tuyệt vời!',
            'Xuất sắc! Bạn trả lời đúng hoàn toàn!',
            'Giỏi lắm! Thật ấn tượng!',
        ],
        dontKnowSelect: [
            'Không sao! Cùng tìm hiểu nhé!',
            'Đừng lo! Xem ví dụ sẽ biết thôi!',
            'Không vấn đề! Cùng xem gợi ý nhé!',
        ],
        maxAttempts: 'Không sao. Cùng tìm hiểu từ vựng này nhé!',
        maxAttemptsNext: 'Hãy xem từ vựng là gì và chuyển sang từ tiếp theo!',
    },
};
